import './Main.css';
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import logo from '../images/logo.svg';
import monogram from '../images/monogram-blue.svg';
import OurStory from './OurStory';
import BigDay from './BigDay';
import Rsvp from './Rsvp/Rsvp';
import Travel from './Travel';
import ThingsToDo from './ThingsToDo';
import Home from './Home';

function Main() {
  return (
    <BrowserRouter>
      <div className="header">
        <div className="container">
          <img src={logo} alt="Logo" height="205px" />
        </div>
      </div>
      <nav>
        <div className="container">
          <Link to="/"><span className="josefin-slab upper">Home</span></Link>
          <Link to="/our-story"><span className="josefin-slab upper">Our Story</span></Link>
          <Link to="/the-big-day"><span className="josefin-slab upper">The <u>Big</u> Day</span></Link>
          <Link to="/travel"><span className="josefin-slab upper">Travel</span></Link>
          <Link to="/things-to-do"><span className="josefin-slab upper">Things to do</span></Link>
          <Link to="/rsvp"><span className="josefin-slab upper">RSVP</span></Link>
        </div>
      </nav>

      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/our-story" element={<OurStory />} />
          <Route path="/the-big-day" element={<BigDay />} />
          <Route path="/travel" element={<Travel />} />
          <Route path="/things-to-do" element={<ThingsToDo />} />
          <Route path="/rsvp" element={<Rsvp />} />
        </Routes>
      </main>

      <footer>
        <div className="container">
          <img className="monogram" src={monogram} alt="" />
        </div>
      </footer>
    </BrowserRouter>
  )
}

export default Main;